import useGetMe from './useGetMe';

/**
 * The Account's proposal-send email body, used to pre-fill the editable body
 * when sending a Proposal. Narrowed from the shared `me` query so it loads with
 * the rest of the current user's data rather than in a separate request.
 */
const useGetMySendProposalEmailBody = () => {
  const { user, ...rest } = useGetMe();

  return {
    emailCopy: user?.account.sendProposalEmailBody ?? '',
    ...rest,
  };
};

export default useGetMySendProposalEmailBody;
